import moment from 'moment';
import { FC } from 'react';
import DatePicker, { DatePickerProps } from 'components/DatePicker';
import FormGroup from 'components/FormGroup';
import { printf } from 'utils/i18n';

export interface BirthdayFormutil {
    birthday: string;
}

interface BirthdayProps extends Pick<DatePickerProps, 'maxDate'> {
    disabled?: boolean;
}

const Birthday: FC<BirthdayProps> = props => {
    const { disabled, maxDate } = props;

    return (
        <FormGroup
            name="birthday"
            label={__('Date of Birth')}
            checker={value => !!value || printf(__('Please select your %s'), __('date of birth'))}
            $parser={value => value.format('YYYY-MM-DD')}
            $formatter={value => (value ? moment(value) : null)}>
            <DatePicker
                disabled={disabled}
                initialDate={moment().subtract(30, 'year')}
                maxDate={maxDate || moment().subtract(18, 'year')}
                minDate={moment().subtract(120, 'year')}
            />
        </FormGroup>
    );
};

export default Birthday;
